<template>
  <FormGroup>
    <FormGroup>
      <FormField
        v-for="[key, value] in accessibilityMap"
        :key="key"
        :label="value"
        :error="form.fieldErrors(key)"
        direction="row"
      >
        <CheckmarkCrossmark v-model="form.fields[key]" />
      </FormField>
    </FormGroup>

    <FormField label="Accessibility notes" :error="form.fieldErrors('accessibilityNotes')">
      <Textarea
        v-model="form.fields.accessibilityNotes"
        placeholder="Describe any accessibility features or accommodations available at your property"
        rows="3"
      />
    </FormField>
  </FormGroup>
</template>

<script setup lang="ts">
import { CheckmarkCrossmark, FormField, FormGroup, Textarea, useForm } from '@tallo/design-system';
import { accessibilityMap } from '@tallo/property';

import { useDetailsHolder } from '../../composables/details-holder';
import { SaveAccessibilityDto } from '../../dtos/save-accessibility.dto.interface';

const holder = useDetailsHolder();
const form = useForm<SaveAccessibilityDto>({
  accessibilityNotes: holder.details?.accessibility?.accessibilityNotes ?? '',
  ...getItems(),
});

function getItems() {
  const items = Array.from(accessibilityMap).map(([key]) => [key, holder.details?.accessibility?.[key] ?? null]);

  return Object.fromEntries(items);
}

async function save() {
  return await form.submit((fields) => holder.saveAccessibility(fields));
}

defineExpose({ save, form });
</script>
